<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><b><a id="page_xi"></a>The Intro-duck-tion</b></h2>
<p class="noindent"><span><b>Here at the Bathroom Readers’ Institute,</b> we’re suckers for cool facts, and we’re constantly quizzing each other: How many gallons of peanut oil does it take to deep-fry a turkey? What cartoon character is prohibited from running for elected office in Texas? Why did the game of bingo used to be called beano?</span></p>
<p class="indent"><span>So a few years ago, when Uncle John noticed that many of the letters we received from fans were asking for the same thing—an entire book of running feet (those fun factoids at the bottom of <i>Bathroom Reader</i> pages)—he called in a team of bathroom-reading writers and sent them on a fact-finding mission: search old <i>Bathroom Readers</i> for running feet and then organize the facts into interesting lists. The finished product turned out so great that even more readers wrote in asking us to do it again.</span></p>
<p class="indent"><span>We got right to work…diving into a whole new batch of <i>Bathroom Readers</i> and pulling out the running feet. We sorted the facts, organized them, argued (gently) about how best to arrange them, and then organized them again. We also came up with 50 <i>new</i> pages of facts.</span></p>
<p class="indent"><span>The end result is <i>Uncle John’s Bathroom Reader Wise Up!</i>, more than 380 pages packed with useful—and sometimes useless—but always interesting information.</span></p>
<p class="indent"><span>If you’re joining us for the first time, welcome! And if you’re on your second <i>Bathroom Reader</i> book of facts, welcome back! We’re really glad you’re here. And as always, go with the flow…</span></p>
<p class="right1"><span><b>—Uncle John and the BRI Staff</b></span></p>
<p class="noindent2"><span>P.S. We’re already gathering new running feet for the next <i>Bathroom Reader</i>. So email your favorite obscure bits of trivia and fun facts to <a href="http://mail@bathroomreader.com" target="_blank"><i>mail@bathroomreader.com</i></a>!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?7ea27a45